import { create } from "zustand";
import { persist } from "zustand/middleware";

const store = (set, get) => ({
  // Device selection (Page 1)
  devices: [],
  selectedDevice: null,

  // Literature files (Page 2)
  literatureFiles: [],

  // Report generation (Page 3 → 4)
  analysisJson: null,
  reportDocxBlob: null,

  // Viewer (Page 4)
  selectedPaperKey: null,

  // Chat (Page 5)
  selectedPaperForChat: null,
  chatMessages: [],

  setDevices: (devices) => set({ devices }),
  setSelectedDevice: (device) => set({ selectedDevice: device }),
  setLiteratureFiles: (files) => set({ literatureFiles: files }),
  setAnalysisJson: (json) => set({ analysisJson: json }),
  setReportDocxBlob: (blob) => set({ reportDocxBlob: blob }),
  setSelectedPaperKey: (key) => set({ selectedPaperKey: key }),
  setSelectedPaperForChat: (paper) => set({ selectedPaperForChat: paper }),
  setChatMessages: (messages) => set({ chatMessages: messages }),
  appendChatMessage: (msg) =>
    set((state) => ({ chatMessages: [...state.chatMessages, msg] })),
  clearChatMessages: () => set({ chatMessages: [] }),

  resetForNewDevice: () =>
    set({
      literatureFiles: [],
      analysisJson: null,
      reportDocxBlob: null,
      selectedPaperKey: null,
      selectedPaperForChat: null,
      chatMessages: [],
    }),
});

export const useDeepLiteratureStore = create(
  persist(store, { name: "deep-literature-store" }),
);
